/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  Buffer,
  CreateDeviceModelDto,
  DeviceModelsControllerAddImageToModelV1PathParameters,
  DeviceModelsControllerCreateDeviceModelV1PathParameters,
  DeviceModelsControllerDeleteStandardModelV1PathParameters,
  DeviceModelsControllerFilterModelsV1PathParameters,
  DeviceModelsControllerGetAllModelsV1PathParameters,
  DeviceModelsControllerGetModelAttributesV1PathParameters,
  DeviceModelsControllerGetRelatedImageV1PathParameters,
  DeviceModelsControllerUpdateDeviceModelV1PathParameters,
  FilterDeviceModelsDto,
  UpdateDeviceModelDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class DeviceModelsService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Create a new device model
   */

  createDeviceModel<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, makerId }: DeviceModelsControllerCreateDeviceModelV1PathParameters,
    createDeviceModelDto: CreateDeviceModelDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/device-makers/${makerId}/device-models`, createDeviceModelDto);
  }
  /**
   * @summary Update the device model
   */

  updateDeviceModel<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, makerId, modelId }: DeviceModelsControllerUpdateDeviceModelV1PathParameters,
    updateDeviceModelDto: UpdateDeviceModelDto,
  ): Observable<TData> {
    return this.http.patch<TData>(
      `/devices/v1/clients/${clientId}/device-makers/${makerId}/device-models/${modelId}`,
      updateDeviceModelDto,
    );
  }
  /**
   * @summary Get a specific device model with attributes
   */

  getModelAttributes<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    makerId,
    modelId,
  }: DeviceModelsControllerGetModelAttributesV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/device-makers/${makerId}/device-models/${modelId}`);
  }
  /**
   * @summary Delete a standard model
   */

  deleteStandardModel<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    makerId,
    modelId,
  }: DeviceModelsControllerDeleteStandardModelV1PathParameters): Observable<TData> {
    return this.http.delete<TData>(`/devices/v1/clients/${clientId}/device-makers/${makerId}/device-models/${modelId}`);
  }
  /**
   * @summary Get client device models with filters applied
   */

  filterModels<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: DeviceModelsControllerFilterModelsV1PathParameters,
    filterDeviceModelsDto: FilterDeviceModelsDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/device-models/filter`, filterDeviceModelsDto);
  }
  /**
   * @summary Get all device models for a client
   */

  getAllModels<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
  }: DeviceModelsControllerGetAllModelsV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/device-models`);
  }
  /**
   * @summary Get the logo image of a device model
   */

  getRelatedImage<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    makerId,
    modelId,
    fileName,
  }: DeviceModelsControllerGetRelatedImageV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/device-makers/${makerId}/device-models/${modelId}/documents/${fileName}`);
  }
  /**
   * @summary Upload a logo for a device model
   */

  addImageToModel<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, makerId, modelId }: DeviceModelsControllerAddImageToModelV1PathParameters,
    buffer: Buffer,
  ): Observable<TData> {
    const formData = new FormData();

    return this.http.put<TData>(`/devices/v1/clients/${clientId}/device-makers/${makerId}/device-models/${modelId}/documents`, formData);
  }
}
